import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';

export default function Button(props) {
  const { label, icon, style = 'main', className, ...rest } = props;
  const cn = clsx(`button`, style, className);
  return (
    <button className={cn} {...rest}>
      {icon}
      {label}
    </button>
  );
}
Button.propTypes = {
  label: PropTypes.any,
  icon: PropTypes.any,
  style: PropTypes.oneOf(['main', 'sub']),
  onClick: PropTypes.func,
  className: PropTypes.any,
};
